import { CategoryService } from './../service/category.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Shop } from './../../shop/types/shop.type';
import { Component, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CardModule } from 'primeng/card';
import { SelectModule } from 'primeng/select';
import { UserService } from '../../user/services/user.service';
import { ShopService } from '../../shop/service/shop.service';
import { User } from '../../user/models/user.type';
import { TreeModule } from 'primeng/tree';
import { Category } from '../category.type';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { MultiSelectModule } from 'primeng/multiselect';
import { TagModule } from 'primeng/tag';
import { ChannelService } from '../service/channel.service';
import { CheckboxModule } from 'primeng/checkbox';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { environment } from '../../../../environments/environment';


@Component({
  selector: 'app-export-file',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    CardModule,
    SelectModule,
    TranslateModule,
    TreeModule,
    InputTextModule,
    ButtonModule,
    MultiSelectModule,
    TagModule,
    CheckboxModule,
    ToastModule,
  ],
  providers: [TranslateService, MessageService],
  templateUrl: './export-file.component.html',
  styleUrl: './export-file.component.scss',
})
export class ExportFileComponent implements OnInit {
  user: User;
  shopInfo: Shop = null;
  selectedCategories = [];
  selectedCategoriesShow = [];
  categories: Category[] = [];
  numberPerParent = {};
  searchValue;
  selectedMarkets = [];
  selections = [];
  numberOfLeafSelected = 0;
  leaves = [];
  categoriesShow = [];
  downloading = false;
  locales = [];
  selectedLocales = [];
  maxSelection = 100;
  selectedIds = new Set();
  leavesCount = 0;
  leavesSelected = 0;
  channels: any[] = [];
  selectedChannel: any;
  loading = true;
  details = [];
  constructor(
    private readonly translate: TranslateService,
    private readonly categoryService: CategoryService,
    private readonly userService: UserService,
    private readonly channelService: ChannelService,
    private readonly messageService: MessageService,
    private readonly shopService: ShopService,
  ) {}

  ngOnInit(): void {
    this.user = this.userService.getUser();
    if (
      this.userService.hasRole([
        'ROLE_SUPER_ADMIN',
        'ROLE_OPERATOR',
        'ROLE_OPERATOR_ADMIN',
      ])
    ) {
      this.channels = this.user.relatedChannels;
    } else {
      const setObj = this.user.relatedShops.map((shop) => shop.shopChannel);
      this.channels = Array.from(
        new Set(setObj.map((channel) => JSON.stringify(channel))),
      ).map((channel) => JSON.parse(channel));
    }

    this.selectedChannel = this.channelService.getSelectedChannel();
    this.initInfo();
  }

  initInfo() {
    this.categories = [];
    this.selectedCategories = [];
    this.selections = [];
    this.getLocales(this.selectedChannel);
    this.initCategories();
  }

  getLocales(channel) {
    this.channelService.getLocales(channel).subscribe({
      next: (res: any) => {
        this.locales = res.locales;
      },
    });
  }

  initCategories() {
    this.loading = true;
    if (this.categories.length == 0) {
      this.categoryService.getCategories().subscribe({
        next: (res: any) => {
          const categories = structuredClone(res);
          this.categories = this.categoryService.getCaterogyByLocale(
            categories,
            this.channelService.getSelectedLocale(),
          );
          this.getLeaves(this.categories);
          this.loading = false;
        },
      });
    }
  }

  getLeaves(categories) {
    for (let c of categories) {
      if (c.children == null || c.children.length == 0) {
        this.leaves.push(c);
      } else {
        this.getLeaves(c.children);
      }
    }
  }

  onCategorySelect(categories) {
    const cat = categories;
    this.selectedCategories = cat;
    this.numberOfLeafSelected = 0;
    for (let e of categories) {
      this.countChildren(e);
      if (this.leaves.some((l) => l.categoryId == e.categoryId)) {
        this.numberOfLeafSelected++;
      }
    }
  }

  onNodeSelect(event) {
    let node = structuredClone(event.node);
    if (this.selections.some((e) => e.categoryId == node.categoryId)) {
      return;
    }
    this.updateSelectedNodes();
  }

  countLeaves(categories) {
    let count = 0;
    for (let category of categories) {
      if (category.hasChildren == 'false') {
        count++;
      }
    }
    return count;
  }

  onNodeUnselect(event) {
    this.selections = this.selections.filter(
      (e) => e.categoryId != event.node.categoryId,
    );
    this.updateSelectedNodes();
  }

  updateSelectedNodes() {
    this.selectedCategories = Object.values(this.selectedCategories);
    this.selections = [];
    this.selectedIds = new Set();
    for (let e of this.selectedCategories) {
      this.selectedIds.add(e.categoryId);
      if (e.hasChildren == 'false') {
        this.selections.push(e);
      }
    }
    this.leavesSelected = this.selections.length;
    if (this.leavesSelected > this.maxSelection) {
      this.setDisabledState(this.categories, false);
      this.messageService.add({
        severity: 'warn',
        summary: this.translate.instant('messages.warning'),
        detail: this.translate
          .instant('exportFile.maxTypologiesExceded')
          .replace('XX', this.maxSelection),
        closable: true,
      });
    } else {
      this.setDisabledState(this.categories, true);
    }
  }

  setDisabledState(categories, state) {
    for (let node of categories) {
      if (!this.selectedIds.has(node.categoryId)) {
        node.selectable = state;
      }
      if (node.children) {
        this.setDisabledState(node.children, state);
      }
    }
  }

  removeNode(node) {
    this.selectedCategories = this.selectedCategories.filter(
      (e) => e.categoryId != node.categoryId,
    );
    this.selections = this.selections.filter(
      (e) => e.categoryId != node.categoryId,
    );
  }

  countChildren(node) {
    if (node.children == null || node.children.length == 0) {
      this.numberPerParent[node.categoryId] = 1;
      return 1;
    } else {
      let count = 0;
      for (let child of node.children) {
        count += this.countChildren(child);
      }
      this.numberPerParent[node.categoryId] = count;
      return count;
    }
  }

  downloadTemplate() {
    this.downloading = true;
    const cat = this.selectedCategories.filter((e) => e.hasChildren == 'false');
    this.categoryService
      .downloadTemplate(
        this.selectedChannel.channelCode,
        this.selectedLocales,
        this.channelService.getSelectedLocale(),
        cat,
      )
      .subscribe({
        next: () => {
          this.downloading = false;
        },
      });
  }
  addNumberPerParent(e) {
    if (e.parentId == null) {
      if (this.numberPerParent[e.categoryId] == undefined) {
        this.numberPerParent[e.categoryId] = 1;
      } else {
        this.numberPerParent[e.categoryId]++;
      }
    } else if (
      e.parentId !== null &&
      this.numberPerParent[e.parentId] == undefined
    ) {
      this.numberPerParent[e.parentId] = 1;
    } else {
      this.numberPerParent[e.parentId]++;
    }
  }

  onChannelChange(event) {
    this.selectedChannel = event;
    this.selectedLocales = [];
    this.initInfo();
  }

  getLink(isTuto: boolean) {
    const url = environment.docsBucketUrl;
    if (this.translate.currentLang === 'fr') {
      return isTuto ? (
        url +
        "Gestion%20des%20imports/FR/Catalog%20-%20FR%20-%20Vendeur%20-%20G%C3%A9n%C3%A9rer%20et%20compl%C3%A9ter%20un%20mod%C3%A8le%20de%20fichier%20d'import.pdf"
      ) : url +
        'Product/FR/Bonnes%20pratiques%20cr%C3%A9ation%20de%20catalogue%20(FR).pdf';
    } else {
      return isTuto ? (
        url +
        "Gestion%20des%20imports/EN/Catalog%20-%20EN%20-%20Seller%20-%20Generate%20and%20fill%20in%20an%20import%20file%20template.pdf"
      ) : url +
        'Product/EN/Catalog%20creation%20best%20practices%20(EN%20CN).pdf';
    }
  }
}
